// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9728da63","389":"9719f013","453":"2893dc41","455":"7b4adafb","977":"43ab11cf"}[chunkId] + ".chunk.js";
};